import * as d3 from 'd3'
import moment from 'moment'

export default {

  methods: {

    set_LocalValues(){
      // raw data
      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))

      // JQueries
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title      = json.title
      this.timeline   = json.timeline
      this.primary    = json.primary
      this.secondary  = json.secondary
      this.chart      = json.chart
      this.legends    = json.legends   
      this.sundries   = json.sundries

      this.timeline.cutoff.date = sql1.CUTOFF
      
      



      
    },


  }
}